export default () => {
    return (
        <div class="team-members-error">
            <h1>Could not load team members</h1>
        </div>
    )
}